import React, { useRef, useReducer, useEffect, useState } from 'react'
import './Addticket.css'
import { ExcelRenderer } from 'react-excel-renderer';
import { Modal } from 'react-bootstrap'
import UploadIcon from '@mui/icons-material/Upload';
import DownloadIcon from '@mui/icons-material/Download';
import Switch from '@material-ui/core/Switch';
import { Spinner } from 'react-bootstrap'
import { Table } from 'react-bootstrap'
import CloseIcon from '@mui/icons-material/Close';
import ShareIcon from '@mui/icons-material/Share';
import IconButton from '@mui/material/IconButton';
import moment from 'moment'
import Empmodal from '../../components/empmodal/Empmodal';
import axios from 'axios';
import Categorypic from '../../components/categorypiker/Categorypic';
import TimeFormatter from '../../utility/TimeFormatter';
import GetImage from '../../components/getimage/Getimage';
import { DatePicker } from '../../components/calendar/Calender';
import { showCustomSwal } from '../../components/customswal/Customswal';
import Empmodalbody from '../../components/empmodal/Empmodalbody';
import TATModalBody from '../../components/tatmodal/Tatmodal';
import { showConfirm } from '../../utility/showconfirm';
import Hexapi from '../../utility/HexAPI/Hexapi';
import TooltipButton from '../../components/tooltip/Popover';
import Tatdate from '../../components/Tatdate';
import Inputbox from '../../components/formcontrols/normal/InputBox';
import Textbox from '../../components/formcontrols/normal/Texbox';
import MyModalBody from '../../components/subcompsActivityModal/MyModalBody';
import withRouter from '../../utility/withRouter';
import { IoCloseOutline } from "react-icons/io5";
import Loader from '../../components/loader/Loader';
import { useSelector } from 'react-redux';
import shortcutpng from '../../assets/shortcut_icon.png'
import { Datetimepicker } from '../../components/calendar/NewDatetimepiker';
function Addticket(props) {
   
    const getAllocatedToEmpID = (search) => {
        const urlParams = new URLSearchParams(search);
        const id = urlParams.get('TicketAllocatedid')
        if (id) {
            return id
        } else {
            return '-1'
        }
    }
    const getCheckedByEmpID = (search, propsArg) => {
        const urlParams = new URLSearchParams(search);
        const id = urlParams.get('TicketAllocatedid')
        if (id) {
            return userid
        } else {
            return '-1'
        }
    }
const getDefaultDueDateTime = () => moment().set({ hour: 23, minute: 59, second: 0, millisecond: 0 }).format('YYYY-MM-DD HH:mm:ss')

   const user = useSelector(state => state?.users?.data?.[""]?.[0])
   const userid = user?.empid ?? null
    const stateRef = useRef({
        excelDownloadUrl: `https://web.trackhrapp.com/GenerateExcelNewv2.php`,
        userid: userid,
       
        isOpencategorymodal: true,
        Description: '',
        categoryIDSelected: '',
        formdata: {
            allocatedtoempids: [`${getAllocatedToEmpID(window.location.search)}`],
            allocatedtoempnames: [''],
            checkedbyempids: [`${getCheckedByEmpID(window.location.search, userid)}`],
            checkedbyempnames: [''],
            remarks: [''],
            predefinedTat: ['-1'],
            predefinedTATStr: [''],
            isPredefinedTATSelected: [false],
            locationOnAction: [false],
            // dueDate: [`${moment(new Date()).format('YYYY-MM-DD HH:mm:ss')}`],
dueDate: [`${getDefaultDueDateTime()}`],
            dueDateStr: [''],
            isDueDateSelected: [false]
        },
        alertNow: false,
        isEditMode: false,
        editRowId: '',
        editRowData: {},
        isParallel: false,
        renderAgain: false,
        defaultStage: 0,
        stageModalCheckedbylabelColor: 'black',
        storeAllocatedToEmpName: [],
        allocatedtoempID: getAllocatedToEmpID(window.location.search),
        CheckedByEmpList: [],
        storeCheckedByEmpName: [],
        checkedbyempID: getCheckedByEmpID(window.location.search),
        AllocatedToEmpList: [],
        isOpenAllocatedempmodal: false,
        isobserverModal: false,
        isOpenCheckedempmodal: false,
        storeRemarksValue: [],
        isOpenTATmodal: false,
        originalTATVAlue: [0],
        isTATselected: false,
        storeTATValue: ['-1'],
        isLocationSelected: [false],
        isAlertnow: false,
        storeduedate: [],
        originalduedate: [new Date()],
        isloadcompleted: true,
        descriptionColor: 'black',
        allocatedToEmpLabelColor: 'black',
        checkedByEmpLabelColor: 'black',
        isAddStageModalOpen: false,
        allocatedToEmpLabelColorInStage: 'black',
        checkedByEmpLabelColorInStage: 'black',
        isMultipleStage: false,
        stageModalallocatedlabelColor: "black",
        stageheaders: ['Stage', 'Allocated To', 'Checked By', 'Predefined TAT', 'Remarks', 'Due Date', 'Action'],
        tableArr: [],
        setFocus: false,
        observerEmpIdslist: '-1',
        categoryColor: false,

        // ---- bulk stage (shortcut to add multiple stages at once) ----
        isOpenBulkStageModal: false,
        isOpenBulkAllocatedModal: false,
        isOpenBulkCheckedEmpModal: false,
        isOpenBulkTATmodal: false,
        isOpenBulkDueDateModal: false,
        bulkAllocatedEmpIds: '-1',
        bulkAllocatedEmpNames: '',
        bulkCheckedByEmpId: '-1',
        bulkCheckedByEmpName: '',
        bulkRemarks: '',
        bulkPredefinedTat: '-1',
        bulkPredefinedTATStr: '',
        bulkIsPredefinedTATSelected: false,
        bulkLocationOnAction: false,
        bulkDueDate: `${getDefaultDueDateTime()}`,
        bulkDueDateStr: '',
        bulkIsDueDateSelected: false,
        bulkAllocatedLabelColor: 'black',
        bulkCheckedByLabelColor: 'black',
    })
const [duedateconfig,setduedateconfig]=useState(false)
    const [, forceRenderTick] = useReducer(x => x + 1, 0)

    // mimics this.setState(updates, callback) — supports both an object
    // and a function updater, and runs the callback after the (mutated)
    // state has been applied, same as class setState.
    const setState = (updater, callback) => {
        const updates = typeof updater === 'function' ? updater(stateRef.current) : updater
        Object.assign(stateRef.current, updates)
        forceRenderTick()
        if (callback) callback()
    }
    const state = stateRef.current

    // ---- componentDidUpdate(prevProps) equivalent (body was empty in the original) ----
    const isMountedRef = useRef(false)
    const prevUseridRef = useRef(userid)
    useEffect(() => {
        if (isMountedRef.current) {
            if (prevUseridRef.current !== userid) {
                // original componentDidUpdate body was empty here
            }
        }
        prevUseridRef.current = userid
    })

    const scrollToMyRef = () => {
        if (document.getElementsByClassName("table-responsive")) {
            const scrollHeight = document.getElementsByClassName('table-responsive')[0].scrollHeight;
            const clientHeight = document.getElementsByClassName('table-responsive')[0].clientHeight;
            const scroll = scrollHeight - clientHeight
            document.getElementsByClassName('table-responsive')[0].scrollTo(0, scroll);
        }
    }

    const selectedEmployees = (empids, empnames) => {
        console.log(empids, empnames)
        if (empids.length > 0 && empnames.length > 0) {
            setState({ isobserverModal: false, observerEmpIdslist: empids.join(','), observerEmpnamelist: empnames.join(',') })
        } else {
            setState({ isobserverModal: false, observerEmpIdslist: '-1', observerEmpnamelist: '' })
        }
        setTimeout(() => {
            console.log(state.observerEmpIdslist, state.observerEmpnamelist)
        }, 200);
    }

    const getHeader = (headers) => {
        return headers.map((head) => {
            return (
                <th key={head} style={{ textAlign: "left" }}>{head}</th>
            )
        })
    }

    const onEditRow = (i) => {
        console.log()
        setState({
            editRowData: {},
            editRowId: null
        }, () => {
            let obj = {}
            for (const key in state.formdata) {
                obj[key] = state.formdata[key][i]
            }
            setState({ editRowData: obj, isAddStageModalOpen: true, isEditMode: true, editRowId: i })
        })
    }

    const closeEditModal = () => {
        setState({ isAddStageModalOpen: false, isEditMode: false })
    }

    useEffect(() => {
        let data = { header: 'Open Ticket' }
        let event = new CustomEvent('myCustomEvent', { detail: data })
        window.parent.document.dispatchEvent(event)

        if (!userid) return
        fetchUserList()
        isMountedRef.current = true

    }, [userid])

    function fetchUserList() {
        const obj = {
            query: `[HRApp_Droid_Proc_AddTicket_GetFormData] @UserID='{0}' `,
            queryArr: [`${userid}`]
        }
        Hexapi(obj).then(resp => {
            console.log(resp,"responsessssssssssssssssssssss")
if(resp && resp?.config && resp?.config?.[0]?.allowduedatetime){
setduedateconfig(true)
}else{
setduedateconfig(false)
}
            if (resp && resp["checkedby"] && resp["checkedby"].length > 0) {
                const filledbyOptions = resp.checkedby.map((filledby) => ({
                    value: filledby.empid,
                    label: `${filledby.firstname} ${filledby.lastname}`,
                }));
                setState({
                    CheckedByEmpList: filledbyOptions,
                })
            } else {
                setState({
                    CheckedByEmpList: [],
                })
            }
            if (resp && resp["allocatedto"] && resp["allocatedto"].length > 0) {
                const filledbyOptions = resp.allocatedto.map((filledby) => ({
                    value: filledby.empid,
                    label: `${filledby.firstname} ${filledby.lastname}`,
                }));
                setState({
                    AllocatedToEmpList: filledbyOptions,
                })
            } else {
                setState({
                    CheckedByEmpList: [],
                })
            }

            const filledbyobserverOptions = resp.observer.map((filledby) => ({
                value: filledby.empid,
                label: `${filledby.firstname} ${filledby.lastname}`,
            }));
            setState({
                observerEmplist: filledbyobserverOptions,
            })

            setState({ renderAgain: true })
        }).catch(err => console.log('Employee fetch user details fetching Error in Store procedure [​​HRApp_Droid_Proc_AddTicket_GetFormData]: ', console.error(err)))
    }

    const getAllocuserid = (id, AllocatedToEmpName, closemodal) => {
        setState({ setFocus: false })
        if (!state.isEditMode) {
            let { allocatedtoempids, allocatedtoempnames } = state.formdata
            allocatedtoempids[state.defaultStage] = id
            allocatedtoempnames[state.defaultStage] = AllocatedToEmpName

            setState({
                isOpenAllocatedempmodal: closemodal,
                allocatedToEmpLabelColor: 'black',
                renderAgain: true
            })
        } else {
            state.editRowData.allocatedtoempids = id
            state.editRowData.allocatedtoempnames = AllocatedToEmpName
            setState({
                isOpenAllocatedempmodal: closemodal,
                allocatedToEmpLabelColor: 'black',
                renderAgain: true
            })
        }
    }

    const getCheckuserid = (id, CheckedByEmpName, closemodal) => {
        setState({ setFocus: false })
        if (!state.isEditMode) {
            let { checkedbyempids, checkedbyempnames } = state.formdata
            checkedbyempids[state.defaultStage] = id
            checkedbyempnames[state.defaultStage] = CheckedByEmpName

            setState({
                isOpenCheckedempmodal: closemodal, checkedByEmpLabelColor: 'black', renderAgain: true
            })
        } else {
            state.editRowData.checkedbyempids = id
            state.editRowData.checkedbyempnames = CheckedByEmpName

            setState({
                isOpenCheckedempmodal: closemodal, checkedByEmpLabelColor: 'black', renderAgain: true
            })
        }
    }

    const getCategoryID = (categoryID) => {
        if (categoryID) {

        }
        setState({
            categoryIDSelected: categoryID, isOpencategorymodal: false, setFocus: false,
            categoryColor: ""
        })
    }

    const getTATvalue = (tat, str) => {
        if (!state.isEditMode) {
            let { predefinedTat, predefinedTATStr } = state.formdata
            predefinedTat[state.defaultStage] = Number(tat)
            if (str == '') {
                predefinedTATStr[state.defaultStage] = '00:00 Hrs'
            } else {
                predefinedTATStr[state.defaultStage] = str
            }

            setState({
                renderAgain: true,
                isTATselected: true, isOpenTATmodal: false
            })
        } else {
            state.editRowData.predefinedTat = Number(tat)
            if (str == '') {
                state.editRowData.predefinedTATStr = '00:00 Hrs'
            } else {
                state.editRowData.predefinedTATStr = str
            }

            setState({
                renderAgain: true,
                isTATselected: true, isOpenTATmodal: false
            })
        }
    }

   
const getDueDate = (date) => {
    let finalDate = duedateconfig ? date : `${moment(date).format('YYYY-MM-DD')} 23:59:00`

    if (!state.isEditMode) {
        let dateObj = TimeFormatter(finalDate)
        let { dueDate, dueDateStr } = state.formdata
        let str = duedateconfig
            ? `${moment(finalDate).format('hh:mm A')}, ${dateObj.userSplitedDate[3]}, ${dateObj.userSplitedDate[2]} ${dateObj.shiftFullMonth} , ${dateObj.userSplitedDate[0]}`
            : `${dateObj.userSplitedDate[3]}, ${dateObj.userSplitedDate[2]} ${dateObj.shiftFullMonth} , ${dateObj.userSplitedDate[0]}`
        dueDate[state.defaultStage] = finalDate
        dueDateStr[state.defaultStage] = str
        setState({ renderAgain: true, isOpenDueDateModal: false })
    } else {
        let dateObj = TimeFormatter(finalDate)
        let str = duedateconfig
            ? `${moment(finalDate).format('hh:mm A')}, ${dateObj.userSplitedDate[3]}, ${dateObj.userSplitedDate[2]} ${dateObj.shiftFullMonth} , ${dateObj.userSplitedDate[0]}`
            : `${dateObj.userSplitedDate[3]}, ${dateObj.userSplitedDate[2]} ${dateObj.shiftFullMonth} , ${dateObj.userSplitedDate[0]}`
        let { dueDate, dueDateStr } = state.formdata
        dueDate[state.defaultStage] = finalDate
        dueDateStr[state.defaultStage] = str
        state.editRowData.dueDate = finalDate
        state.editRowData.dueDateStr = str

        setState({
            renderAgain: true,
            isDueDateSelected: true, isOpenDueDateModal: false
        })
    }
}
    async function Addticket(e) {
        e.preventDefault();

        let isApiCanHit = true

        let {
            allocatedtoempnames, checkedbyempnames, allocatedtoempids, checkedbyempids,
            remarks, predefinedTat, locationOnAction,
            dueDate, isDueDateSelected
        } = state.formdata

        if (state.isMultipleStage == true) {
            if (state.Description == "") {
                isApiCanHit = false
                setState({ descriptionColor: 'red' })
            } else {
                setState({ descriptionColor: 'black' })
            }

            if (isApiCanHit) {
                setState({ isloadcompleted: false })
                let description = state.Description
                let categoryid = state.categoryIDSelected
                
                let Allocatedtoempids = allocatedtoempids.join('$1*2$$$')
                let Checkedbyempids = checkedbyempids.join('$1*2$$$')
                let Remarks = remarks.join('$1*2$$$')
                let TATs = predefinedTat.join('$1*2$$$')
                console.log(predefinedTat, "predefinedTat")
                console.log(TATs, "TATs")
                let DueDates = dueDate.join('$1*2$$$')
                let GPSs = locationOnAction.join('$1*2$$$').replaceAll('false', '0').replaceAll('true', '1')
                let parallelStage = state.isParallel ? '1' : '0'
                let Alert = (state.alertNow == true) ? "1" : "0"

                const obj = {
                    query: `HRApp_Droid_Proc_AddTicket_Linked_SubmitV5 @Description='{0}',@CategoryID='{1}',@UserID='{2}',@AllocatedToEmpIDs='{3}',@CheckedByEmpIDs='{4}',@Remarks='{5}',@TATs='{6}',@GPSonActionsList='{7}',@ParallelStage='{8}',@DueDates='{9}',@AlertNow='{10}',@ObserverEmpIDs='{11}'`,
                    queryArr: [`${description}`, `${categoryid}`, `${userid}`, `${Allocatedtoempids}`, `${Checkedbyempids}`, `${Remarks}`, `${TATs}`, `${GPSs}`, `${parallelStage}`, `${DueDates}`, `${Alert}`, `${state.observerEmpIdslist}`]
                }
                const resp = await Hexapi(obj)

                await showConfirm({
                    content: resp[''][0].msg,
                    hideCancel: true,
                }).then(() => {
                    if (resp[''][0].command != "0") {
                        
if(props?.isweb){
props?.onHide?.()
}else{
                        props.navigate(-1)
}


                    }
                })

            }
        } else {
            if (state.Description == "") {
                isApiCanHit = false
                setState({ descriptionColor: 'red' })
            } else {
                setState({ descriptionColor: 'black' })
            }
            if (state.categoryIDSelected == "") {
                isApiCanHit = false
                setState({ categoryColor: 'red' })
            } else {
                setState({ categoryColor: 'black' })
            }

            if (allocatedtoempnames[0] == '') {
                isApiCanHit = false
                setState({ allocatedToEmpLabelColor: 'red' })
            } else {
                setState({ allocatedToEmpLabelColor: 'black' })
            }

            if (checkedbyempnames[0] == '') {
                isApiCanHit = false
                setState({ checkedByEmpLabelColor: 'red' })
            } else {
                setState({ checkedByEmpLabelColor: 'black' })
            }

            if (isApiCanHit) {
                setState({ isloadcompleted: false })
                var GPS = (locationOnAction[0] == true) ? "1" : "0"
                var Alert = (state.alertNow == true) ? "1" : "0"
                console.log(state)
                console.log(GPS, Alert)
                var TAT = predefinedTat[0]
                var duedate = isDueDateSelected[0] ? dueDate[0] : '-1'

                const obj = {
                    query: "[HRApp_Droid_Proc_AddTicket_SubmitV5] @Description='{0}',@CategoryID='{1}',@UserID ='{2}',@AllocatedTo ='{3}',@CheckedBy ='{4}',@TAT ='{5}',@Remarks ='{6}',@GPSOnActions='{7}',@DueDate ='{8}',@AlertNow ='{9}',@ObserverEmpIDs='{10}'",
                    queryArr: [`${state.Description}`, `${state.categoryIDSelected}`, `${userid}`, `${allocatedtoempids[0]}`, `${checkedbyempids[0]}`, `${TAT}`, `${remarks[0]}`, `${GPS}`, `${duedate}`, `${Alert}`, `${state.observerEmpIdslist}`]
                }
console.log(obj)
                Hexapi(obj).then(async (resp) => {
                    console.log(resp)
                    await showConfirm({
                        content: resp[''][0].msg,
                        hideCancel: true,
                    }).then(() => {
                        if (resp[''][0].command != "0") {
if(props?.isweb){
props?.onHide?.()
}else{
                        props.navigate(-1)
}
                        }
                    })
                }).then(resp => setState({ isloadcompleted: true })).catch(err => console.error('Error of ' + + ' : ' + err + ' with url => (' + + ')'))
            }
        }
    }

    function AddStages(e) {
        e.preventDefault()
        let { checkedbyempnames, allocatedtoempnames } = state.formdata
        let isAddStage = true
        // if (state.Description == "") {
        //     isAddStage = false
        //     setState({ descriptionColor: 'red' })
        // }

        if (checkedbyempnames[state.defaultStage] == "") {
            isAddStage = false
            setState({ checkedByEmpLabelColor: 'red' })
        }

        if (allocatedtoempnames[state.defaultStage] == "") {
            isAddStage = false
            setState({ allocatedToEmpLabelColor: 'red' })
        }

        if (isAddStage) {
            setState({ isEditMode: false })
            let {
                allocatedtoempnames, checkedbyempnames, allocatedtoempids, checkedbyempids,
                remarks, predefinedTat, predefinedTATStr, isPredefinedTATSelected, locationOnAction,
                dueDate, dueDateStr, isDueDateSelected
            } = state.formdata
            let newDefaultStage = state.defaultStage + 1
            // allocatedtoempnames[newDefaultStage] = checkedbyempnames[newDefaultStage - 1]
            allocatedtoempnames[newDefaultStage] = ''
            allocatedtoempids[newDefaultStage] = '-1'
            // allocatedtoempids[newDefaultStage] = checkedbyempids[newDefaultStage - 1]
            checkedbyempids[newDefaultStage] = '-1'
            checkedbyempnames[newDefaultStage] = ''
            remarks[newDefaultStage] = ''
            predefinedTat[newDefaultStage] = '-1'
            predefinedTATStr[newDefaultStage] = ''
            isPredefinedTATSelected[newDefaultStage] = false
            locationOnAction[newDefaultStage] = false
            dueDate[newDefaultStage] = `${moment(new Date()).format('YYYY-MM-DD HH:mm:ss')}`
            dueDateStr[newDefaultStage] = ''
            isDueDateSelected[newDefaultStage] = false
            setState({ renderAgain: true, isMultipleStage: true, isAddStageModalOpen: true, defaultStage: newDefaultStage })
            if (newDefaultStage - 1 == 0) {
                let newArr = []
                for (let i = 0; i < newDefaultStage; i++) {
                    let obj = {
                        allocatedtoempname: allocatedtoempnames[i],
                        allocatedtoempid: allocatedtoempids[i],
                        checkedbyempname: checkedbyempnames[i],
                        checkedbyempid: checkedbyempids[i],
                        predefinedTATstr: predefinedTATStr[i],
                        remarks: remarks[i],
                    }
                    newArr.push(obj)
                }
                setState({ tableArr: newArr })
            }
        }
        console.log(state.formData)
    }

    const closeStageModal = () => {
        if (!state.isEditMode) {
            let {
                allocatedtoempnames, checkedbyempnames, allocatedtoempids, checkedbyempids,
                remarks, predefinedTat, predefinedTATStr, isPredefinedTATSelected, locationOnAction,
                dueDate, dueDateStr, isDueDateSelected
            } = state.formdata

            let currentStage = state.defaultStage

            let newDefaultStage = state.defaultStage - 1
            allocatedtoempnames[currentStage] = ''
            allocatedtoempids[currentStage] = '-1'
            checkedbyempids[currentStage] = '-1'
            checkedbyempnames[currentStage] = ''
            remarks[currentStage] = ''
            predefinedTat[currentStage] = '-1'
            predefinedTATStr[currentStage] = ''
            isPredefinedTATSelected[currentStage] = false
            locationOnAction[currentStage] = false
            dueDate[currentStage] = `${moment(new Date()).format('YYYY-MM-DD HH:mm:ss')}`
            dueDateStr[currentStage] = ''
            isDueDateSelected[currentStage] = false
            if (newDefaultStage == 0) {
                setState({ isMultipleStage: false })
            }
            setState({
                isAddStageModalOpen: false,
                renderAgain: true,
                defaultStage: newDefaultStage
            })
        } else {
            setState({ isAddStageModalOpen: false, isEditMode: false })
        }
    }

    const openBulkStageModal = () => {
    setState({
        isOpenBulkStageModal: true,
        bulkAllocatedEmpIds: '-1',
        bulkAllocatedEmpNames: '',
        bulkCheckedByEmpId: '-1',
        bulkCheckedByEmpName: '',
        bulkRemarks: '',
        bulkPredefinedTat: '-1',
        bulkPredefinedTATStr: '',
        bulkIsPredefinedTATSelected: false,
        bulkLocationOnAction: false,
        bulkDueDate: `${getDefaultDueDateTime()}`,   // 👈 fix
        bulkDueDateStr: '',
        bulkIsDueDateSelected: false,
        bulkAllocatedLabelColor: 'black',
        bulkCheckedByLabelColor: 'black',
    })
}

    const closeBulkStageModal = () => {
        setState({ isOpenBulkStageModal: false })
    }

    const getBulkAllocatedEmployees = (empids, empnames) => {
        if (empids.length > 0 && empnames.length > 0) {
            setState({ isOpenBulkAllocatedModal: false, bulkAllocatedEmpIds: empids.join(','), bulkAllocatedEmpNames: empnames.join(','), bulkAllocatedLabelColor: 'black' })
        } else {
            setState({ isOpenBulkAllocatedModal: false, bulkAllocatedEmpIds: '-1', bulkAllocatedEmpNames: '' })
        }
    }

    const getBulkCheckedByEmp = (id, name, closemodal) => {
        setState({ isOpenBulkCheckedEmpModal: closemodal, bulkCheckedByEmpId: id, bulkCheckedByEmpName: name, bulkCheckedByLabelColor: 'black' })
    }

    const getBulkTATvalue = (tat, str) => {
        setState({
            bulkPredefinedTat: Number(tat),
            bulkPredefinedTATStr: str == '' ? '00:00 Hrs' : str,
            bulkIsPredefinedTATSelected: true,
            isOpenBulkTATmodal: false
        })
    }

    const closeBulkTATModal = () => {
        setState({ isOpenBulkTATmodal: false, bulkIsPredefinedTATSelected: false, bulkPredefinedTat: '-1', bulkPredefinedTATStr: '' })
    }

const getBulkDueDate = (date) => {
    let finalDate = duedateconfig ? date : `${moment(date).format('YYYY-MM-DD')} 23:59:00`
    let dateObj = TimeFormatter(finalDate)
    let str = duedateconfig
        ? `${moment(finalDate).format('hh:mm A')}, ${dateObj.userSplitedDate[3]}, ${dateObj.userSplitedDate[2]} ${dateObj.shiftFullMonth} , ${dateObj.userSplitedDate[0]}`
        : `${dateObj.userSplitedDate[3]}, ${dateObj.userSplitedDate[2]} ${dateObj.shiftFullMonth} , ${dateObj.userSplitedDate[0]}`
    setState({ bulkDueDate: finalDate, bulkDueDateStr: str, isOpenBulkDueDateModal: false, bulkIsDueDateSelected: true })
}

    const submitBulkStage = () => {
        let isValid = true
        if (state.bulkAllocatedEmpIds == '-1' || state.bulkAllocatedEmpIds == '') {
            isValid = false
            setState({ bulkAllocatedLabelColor: 'red' })
        } else {
            setState({ bulkAllocatedLabelColor: 'black' })
        }
        if (state.bulkCheckedByEmpId == '-1' || state.bulkCheckedByEmpId == '') {
            isValid = false
            setState({ bulkCheckedByLabelColor: 'red' })
        } else {
            setState({ bulkCheckedByLabelColor: 'black' })
        }
        if (!isValid) return

        const allocIds = state.bulkAllocatedEmpIds.split(',')
        const allocNames = state.bulkAllocatedEmpNames.split(',')

        let {
            allocatedtoempids, allocatedtoempnames, checkedbyempids, checkedbyempnames,
            remarks, predefinedTat, predefinedTATStr, isPredefinedTATSelected,
            locationOnAction, dueDate, dueDateStr, isDueDateSelected
        } = state.formdata

        let startIndex
        let newTableArr

        if (state.isMultipleStage) {

            startIndex = state.defaultStage + 1
            newTableArr = [...state.tableArr]
        } else {
        
            const stageZeroHasData = allocatedtoempnames[0] && allocatedtoempnames[0] !== ''
            if (stageZeroHasData) {
                startIndex = 1
                newTableArr = [{
                    allocatedtoempname: allocatedtoempnames[0],
                    allocatedtoempid: allocatedtoempids[0],
                    checkedbyempname: checkedbyempnames[0],
                    checkedbyempid: checkedbyempids[0],
                    predefinedTATstr: predefinedTATStr[0],
                    remarks: remarks[0],
                    dueDateStr: dueDateStr[0]
                }]
            } else {
                startIndex = 0
                newTableArr = []
            }
        }

        allocIds.forEach((empid, idx) => {
            const stageIndex = startIndex + idx
            allocatedtoempids[stageIndex] = empid
            allocatedtoempnames[stageIndex] = allocNames[idx]
            checkedbyempids[stageIndex] = state.bulkCheckedByEmpId
            checkedbyempnames[stageIndex] = state.bulkCheckedByEmpName
            remarks[stageIndex] = state.bulkRemarks
            predefinedTat[stageIndex] = state.bulkPredefinedTat
            predefinedTATStr[stageIndex] = state.bulkPredefinedTATStr
            isPredefinedTATSelected[stageIndex] = state.bulkIsPredefinedTATSelected
            locationOnAction[stageIndex] = state.bulkLocationOnAction
            dueDate[stageIndex] = state.bulkDueDate
            dueDateStr[stageIndex] = state.bulkDueDateStr
            isDueDateSelected[stageIndex] = state.bulkIsDueDateSelected

            newTableArr.push({
                allocatedtoempname: allocNames[idx],
                allocatedtoempid: empid,
                checkedbyempname: state.bulkCheckedByEmpName,
                checkedbyempid: state.bulkCheckedByEmpId,
                predefinedTATstr: state.bulkPredefinedTATStr,
                remarks: state.bulkRemarks,
                dueDateStr: state.bulkDueDateStr
            })
        })

        setState({
            tableArr: newTableArr,
            defaultStage: startIndex + allocIds.length - 1,
            isMultipleStage: true,
            isParallel: true,
            isOpenBulkStageModal: false,
            renderAgain: true
        })
        scrollToMyRef()
    }

    const storeRemarksValue = (e) => {
        if (!state.isEditMode) {
            let { remarks } = state.formdata
            remarks[state.defaultStage] = e.target.value
            setState({ renderAgain: true })
        } else {
            state.editRowData.remarks = e.target.value
            setState({ renderAgain: true })
        }
       
    }

    const CloseTATModal = () => {
        console.log("calerrhjfd")
        if (!state.isEditMode) {
            let { isPredefinedTATSelected } = state.formdata;
            isPredefinedTATSelected[state.defaultStage] = false;
            setState({
                isOpenTATmodal: false,
                renderAgain: true,
            });
        } else {
            state.editRowData.isPredefinedTATSelected = false;
            setState({
                isOpenTATmodal: false,
                renderAgain: true,
            });
        }
    }

    const OpenTATModal = (e) => {
        if (!state.isEditMode) {
            let { isPredefinedTATSelected, predefinedTat, predefinedTATStr } = state.formdata
            isPredefinedTATSelected[state.defaultStage] = e.target.checked
            setState({ renderAgain: true, isOpenTATmodal: e.target.checked })
            if (!e.target.checked) {
                predefinedTat[state.defaultStage] = '-1'
                predefinedTATStr[state.defaultStage] = ''
            }
        } else {
            state.editRowData.isPredefinedTATSelected = e.target.checked
            setState({ renderAgain: true, isOpenTATmodal: e.target.checked })
            if (!e.target.checked) {
                state.editRowData.predefinedTat = '-1'
                state.editRowData.predefinedTATStr = ''
            }
        }
    }

    const ExportFile = async (e) => {
        if (!userid) return;
        e.preventDefault()
        // setisloading(true)
        const obj = {
            query: `[dbo].[HRApp_Droid_Proc_AddTicket_Import_Template_getData] @UserID='{0}'`,
            queryArr: [`${userid}`]
        }

        Hexapi(obj)
            .then((resp) => {
                console.log(resp, "clg")
                // setisloading(false)
                function setDate(date) {
                    var dateObj = TimeFormatter(date)
                    var str = dateObj.userSplitedDate[2] + ' ' + dateObj.ShiftMonth + ' ' + dateObj.userSplitedDate[0]
                    return str
                }

                var today = new Date();
                var dd = String(today.getDate()).padStart(2, '0');
                var mm = String(today.getMonth() + 1).padStart(2, '0');
                var yyyy = today.getFullYear();
                var hrs = String(today.getHours()).padStart(2, '0')
                var mins = String(today.getMinutes()).padStart(2, '0')
                var newfilename = `trackhr_add_ticket_template_${yyyy}${mm}${dd}_${hrs}${mins}`
                console.log()
                var datakeys = Object.keys(resp)
                let tableObj = {},
                    validations = {}
                for (const key in resp) {
                    console.log(datakeys, "datakeys")
                    var arr = []
                    if (key != 'fileinfo') {
                        if (key == "validations") {
                            console.log('validationstest')
                            validations['validations'] = resp[key]
                            console.log(resp[key])
                        } else {
                            let data = resp[key]
                            console.log(data, "dataaaaaaaaaaa")
                            for (let i = 0; i < data.length; i++) {
                                let rowKeys = Object.keys(data[i])
                                let obj = {}
                                for (let j = 0; j < rowKeys.length; j++) {
                                    if (data[i][rowKeys[j]] == "null") {
                                        data[i][rowKeys[j]] = ''
                                    }
                                    if (data[i][rowKeys[j]] != undefined && data[i][rowKeys[j]] != null && data[i][rowKeys[j]].date != undefined && data[i][rowKeys[j]].date != null) {
                                        obj[rowKeys[j]] = setDate(data[i][rowKeys[j]]['date'])
                                    } else {
                                        obj[rowKeys[j]] = data[i][rowKeys[j]]
                                    }
                                }
                                arr.push(obj)
                            }

                            tableObj[key] = arr
                        }

                    }
                }

                if (document.getElementById('tabledata')) {
                    document.getElementById('tabledata').value = JSON.stringify(tableObj)
                    document.getElementById('filename').value = newfilename
                    document.getElementById('validations').value = JSON.stringify(validations)

                    if (tableObj && newfilename) {
                        document.getElementById('ExcelExport').click();

                        setTimeout(() => {
                            setState({ isOpenBulkUploadList: false })
                        }, 1200);
                    }
                }

            }).catch((error) => {
                setState({ isOpenBulkUploadList: false })
                if (error.message == "SQL Error occurred") {
                    showCustomSwal("error occurred please try again")

                }

            })
    }

    const ImportFile = async (e) => {
        if (!userid) return;
        const fileObj = e.target.files[0];
        if (!fileObj) {
            return;
        }

        e.target.value = null;

        if (typeof ExcelRenderer !== "function") {

            return;
        }

        try {
            const data = await new Promise((resolve, reject) => {

                ExcelRenderer(fileObj, (err, resp) => {
                    if (err) {
                        console.error("ExcelRenderer failed:", err);
                        reject(err);
                        return;
                    }
                    console.log(" ExcelRenderer success:", resp);

                    if (!resp.rows || resp.rows.length < 2) {
                        console.error(" Excel file has no data");
                        reject(new Error("Empty file"));
                        return;
                    }

                    const headers = resp.rows[0];
                    const result = [];

                    for (let i = 1; i < resp.rows.length; i++) {
                        const row = resp.rows[i];
                        const obj = {};

                        headers.forEach((key, j) => {
                            let val = row[j] || "";
                            if (key?.includes("(yyyy-MM-dd)")) {
                                key = key.split("(yyyy-MM-dd)")[0];
                                val = typeof val === "number" ? convertExcelDate(val) : val;
                            }
                            obj[key] = val;
                        });

                        result.push(obj);
                    }

                    resolve(result);
                    setState({ isOpenBulkUploadList: false })
                });
            });

            console.log("Parsed Excel result:", data);

            const json = JSON.stringify(data);
            const obj = {
                query: `[dbo].[HRApp_Droid_Proc_AddTicket_Import_Submit] @UserID='{0}', @Json='{1}'`,
                queryArr: [`${userid}`, json],
            };

            console.log(" Sending to Hexapi:", obj);

            if (typeof Hexapi !== "function") {
                console.error("Hexapi not defined");
                return;
            }

            const resp = await Hexapi(obj);
            console.log("Hexapi response:", resp);

            if (resp?.[""]?.[0]) {
                await showConfirm({
                    content: resp[''][0].msg,
                    hideCancel: true,
                })

            } else {
                await showConfirm({
                    content: "No response received from server",
                    hideCancel: true,
                })

            }

        } catch (err) {
            if (err.message == "SQL Error occurred") {
                showCustomSwal("error occurred please try again")

            }

        }
    };

    const convertExcelDate = (date) => {
        const jsDate = new Date(Math.round((date - 25569) * 864e5));
        return jsDate.toISOString().split("T")[0];
    };

    const openDueDateModal = (e) => {
        if (!state.isEditMode) {
            let { isDueDateSelected, dueDate, dueDateStr } = state.formdata
            isDueDateSelected[state.defaultStage] = e.target.checked
            setState({ renderAgain: true, isOpenDueDateModal: e.target.checked })
            if (!e.target.checked) {
                dueDate[state.defaultStage] = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
                dueDateStr[state.defaultStage] = ''
            }
        } else {
            state.editRowData.isDueDateSelected = e.target.checked
            setState({ renderAgain: true, isOpenDueDateModal: e.target.checked })
            if (!e.target.checked) {
                state.editRowData.dueDate = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
                state.editRowData.dueDateStr = ''
            }
        }
    }

    const storeLocations = (e) => {
        if (!state.isEditMode) {
            let { locationOnAction } = state.formdata
            locationOnAction[state.defaultStage] = e.target.checked
            setState({ renderAgain: true })
        } else {
            state.editRowData.locationOnAction = e.target.checked
            setState({ renderAgain: true })
        }
    }

    const storeAlerNow = (e) => {
        console.log(e.target.checked)
        setState({ alertNow: e.target.checked, renderAgain: true })
    }

    const onAddStageSuccess = () => {
        if (!state.isEditMode) {
            console.log("hey calleddd")
            let {
                allocatedtoempnames, checkedbyempnames, allocatedtoempids, checkedbyempids,
                remarks, predefinedTat, predefinedTATStr, isPredefinedTATSelected, locationOnAction,
                dueDate, dueDateStr, isDueDateSelected
            } = state.formdata

            let isStageCanAdd = true
            if (checkedbyempnames[state.defaultStage] == "") {
                isStageCanAdd = false
                setState({ stageModalCheckedbylabelColor: 'red' })
            } else {
                setState({ stageModalCheckedbylabelColor: 'black' })
            }
            if (allocatedtoempnames[state.defaultStage] == "") {
                isStageCanAdd = false
                setState({ stageModalallocatedlabelColor: 'red' })
            } else {
                setState({ stageModalallocatedlabelColor: 'black' })
            }

            if (isStageCanAdd) {
                let newDefaultStage = state.defaultStage + 1
                let newArr = []
                for (let i = 0; i < newDefaultStage; i++) {
                    let obj = {
                        allocatedtoempname: allocatedtoempnames[i],
                        allocatedtoempid: allocatedtoempids[i],
                        checkedbyempname: checkedbyempnames[i],
                        checkedbyempid: checkedbyempids[i],
                        // stage: `Stage ${i + 1}/${newDefaultStage}`,
                        predefinedTATstr: predefinedTATStr[i],
                        remarks: remarks[i],
                        dueDateStr: dueDateStr[i]
                        // currentStage: i
                    }
                    newArr.push(obj)
                    // console.error('hello')
                }
                setState({
                    tableArr: newArr,
                    renderAgain: true,
                    isAddStageModalOpen: false,
                })
                scrollToMyRef();
            }
        } else {
            console.log("heyy here")
            let {
                allocatedtoempnames, checkedbyempnames, allocatedtoempids, checkedbyempids,
                remarks, predefinedTat, predefinedTATStr, isPredefinedTATSelected, locationOnAction,
                dueDate, dueDateStr, isDueDateSelected
            } = state.editRowData
            console.log(state.editRowData)
            let isStageCanAdd = true
            if (state.editRowData.checkedbyempnames == "") {
                isStageCanAdd = false
                setState({ stageModalCheckedbylabelColor: 'red' })
            } else {
                setState({ stageModalCheckedbylabelColor: 'black' })
            }

            if (isStageCanAdd) {
                let newDefaultStage = state.defaultStage + 1
                let obj = {}
                for (let i = 0; i < state.tableArr.length; i++) {
                    if (i == state.editRowId) {
                        obj = {
                            "allocatedtoempname": state.editRowData.allocatedtoempnames,
                            "allocatedtoempid": state.editRowData.allocatedtoempids,
                            "checkedbyempname": state.editRowData.checkedbyempnames,
                            "checkedbyempid": state.editRowData.checkedbyempids,
                            "predefinedTATstr": state.editRowData.predefinedTATStr,
                            "remarks": state.editRowData.remarks,
                            "dueDateStr": state.editRowData.dueDateStr
                        }
                    }
                }
                state.tableArr[state.editRowId] = obj

                state.formdata.allocatedtoempnames[state.editRowId] = allocatedtoempnames
                state.formdata.checkedbyempnames[state.editRowId] = checkedbyempnames
                state.formdata.allocatedtoempids[state.editRowId] = allocatedtoempids
                state.formdata.checkedbyempids[state.editRowId] = checkedbyempids
                state.formdata.remarks[state.editRowId] = remarks
                state.formdata.predefinedTat[state.editRowId] = predefinedTat
                state.formdata.predefinedTATStr[state.editRowId] = predefinedTATStr
                state.formdata.isPredefinedTATSelected[state.editRowId] = isPredefinedTATSelected
                state.formdata.locationOnAction[state.editRowId] = locationOnAction
                state.formdata.dueDate[state.editRowId] = dueDate
                state.formdata.dueDateStr[state.editRowId] = dueDateStr
                state.formdata.isDueDateSelected[state.editRowId] = isDueDateSelected

                setState({
                    isEditMode: false,
                    renderAgain: true,
                    isAddStageModalOpen: false,
                })
                scrollToMyRef();
            }
        }
        console.log(state.formdata)
    }

    const removeTableRow = (e,rowid) => {
e.stopPropagation()
        console.log(rowid)
        var spliced = state.tableArr.splice(rowid, 1)
        setState({ defaultStage: state.defaultStage - 1 }, () => {
            let {
                allocatedtoempnames, checkedbyempnames, allocatedtoempids, checkedbyempids,
                remarks, predefinedTat, predefinedTATStr, isPredefinedTATSelected, locationOnAction,
                dueDate, dueDateStr, isDueDateSelected
            } = state.formdata

            allocatedtoempids.splice(rowid, 1)
            checkedbyempids.splice(rowid, 1)
            allocatedtoempnames.splice(rowid, 1)
            checkedbyempnames.splice(rowid, 1)
            remarks.splice(rowid, 1)
            predefinedTATStr.splice(rowid, 1)
            predefinedTat.splice(rowid, 1)
            isPredefinedTATSelected.splice(rowid, 1)
            locationOnAction.splice(rowid, 1)
            dueDate.splice(rowid, 1)
            dueDateStr.splice(rowid, 1)
            isDueDateSelected.splice(rowid, 1)

            setState({
                isAddStageModalOpen: false,
                renderAgain: true
            }, () => {
                if (state.defaultStage == 0) {
                    setState({ isEditMode: false, isMultipleStage: false, isParallel: false })
                }
            })
        })
    }

    return (
        <div style={{
            width: "100%",
            height: !props?.isweb &&  "calc(91vh - 10px)",
            display:!props?.isweb  && "flex",
            justifyContent: !props?.isweb  &&  "center",
            alignItems: !props?.isweb  &&  "center",
            overflow: "hidden"

        }}>
            <div className='boxcss' style={{ height: "78vh", overflowY: "auto", scrollbarWidth: "none", overflowX: "hidden" }}>
                <div className='container-fluid form_mainBox ' style={{ borderRadius: "10px", display: "block", backgroundColor: 'var(--smBox)', width: !props?.isweb  &&  "900px" }}>
                    <div className="form_topRow p-2">
                        <div className="row mb-1">
                            <div className="col-md-2 col-2 form_categorypicadd" style={{ border: state.categoryColor == 'red' ? "3px solid red" : "" }} onClick={() => setState({ isOpencategorymodal: true })}>
                                <Categorypic categoryID={(state.categoryIDSelected == '' ? '' : state.categoryIDSelected)} setcolrborder={() => setState({ categoryColor: "" })} />
                            </div>
                            <div className="col-md-7 col-7">
                               
                                <Textbox
                                    htmlFor={"description"}
                                    name="description"
                                    id="descriptionInput"

                                    required={true}
                                    value={state.Description}
                                    label={"DESCRIPTION"}
                                    type="text"
                                    labelStyle={{ fontSize: "14px", fontWeight: "600", color: state.descriptionColor }}
                                    placeholder={`Enter description`}
                                    readOnly={false}
                                    onChange={(e) => setState({ Description: e.target.value, descriptionColor: 'black' })}
                                    wordboundation={{ limit: 150, id: 'descriptionInput' }}
                                    fieldName="TicketDescription"
                                />
                            </div>
                          <div className="col-md-3 setdone">

    <IconButton
        size="small"
        title="Bulk Add Stages"
        style={{ padding: 4 }}
        onClick={(e) => {
            e.stopPropagation();
            openBulkStageModal();
        }}
    >
        <img src={shortcutpng} className='img-fluid' width={"22px"} />
    </IconButton>

    <span
        id="saveBtnadd"
        onClick={(e) => {
            localStorage.setItem("refresh", "true");
            Addticket(e);
        }}
        style={{ cursor: "pointer" }}
    >
        SAVE
    </span>

    <button
        type="button"
        className="bulkuploadBtnadd"
        style={{ zIndex: 10 }}
        onClick={() => {
            setState({ isOpenBulkUploadList: true });
        }}
    >
        <UploadIcon /> Bulk Upload
    </button>

</div>

                            <div>
                            </div>

                        </div>
                    </div>

                    <div className="FirstStageDiv" style={{ display: state.isMultipleStage ? "none" : 'block' }}>
                        <div className="row">
                            <div className="col-md-12 col-12">
                                <Inputbox
                                    htmlFor={"ALLOCATED"}
                                    label={"ALLOCATED TO"}
                                    type="text"
                                    labelStyle={{ fontSize: "14px", fontWeight: "600", color: state.allocatedToEmpLabelColor }}
                                    placeholder={`Select Allocated to`}
                                    value={state.formdata.allocatedtoempnames[0]}
                                    onClick={() => setState({ isOpenAllocatedempmodal: true })}
                                    readOnly={true}
                                    required={true}
                                    fieldName="TicketAllocatedTo"
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 col-12">
                                <Inputbox
                                    htmlFor={"CHECKED"}
                                    label={"CHECKED BY"}
                                    type="text"
                                    labelStyle={{ fontSize: "14px", fontWeight: "600", color: state.checkedByEmpLabelColor }}
                                    placeholder={`Select Checked By`}
                                    value={state.formdata.checkedbyempnames[0]}
                                    onClick={() => setState({ isOpenCheckedempmodal: true })}
                                    readOnly={true}
                                    required={true}
                                    fieldName="TicketCheckedBy"
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 col-12">
                                <Inputbox
                                    wordboundation={{ limit: 150, id: 'remarksInput' }}
                                    htmlFor={"REMARKS"}
                                    label={"REMARKS"}
                                    value={state.formdata.remarks[0]}
                                    onChange={(e) => storeRemarksValue(e)}
                                    type="text"
                                    labelStyle={{ fontSize: "14px", fontWeight: "600", color: "black" }}
                                    placeholder={`Enter value`}
                                    required={false}
                                    fieldName="TicketRemarks"
                                />
                            </div>
                        </div>
                        <div className="tatmodal">
                            <div className="row">

                                <div className="col-6">
                                    <Tatdate
                                        label='PREDEFINED TAT'
                                        fieldName="TicketPredefinedTAT"
                                        isChecked={state.formdata.isPredefinedTATSelected[0]}
                                        onSwitchChange={(e) => OpenTATModal(e)}
                                        inputValue={state.formdata.predefinedTATStr[0]}
                                        onInputClick={() => setState({ isOpenTATmodal: true })}
                                    />

                                </div>
                                <div className="col-6">
                                    <Tatdate
                                        label='Due Date'
                                        fieldName={"TicketDueDate"}
                                        isChecked={state.formdata.isDueDateSelected[0]}
                                        onSwitchChange={(e) => openDueDateModal(e)}
                                        inputValue={state.formdata.dueDateStr[0]}
                                        onInputClick={() => setState({ isOpenDueDateModal: true })}
                                    />
                                </div>

                            </div>
                        </div>
                        <div className="locationmodal">
                            <div className="row">
                                <div className="col-md-6 col-6">
                                    <Tatdate
                                        label='LOCATIONS ON ACTIONS'
                                        fieldName={"TicketLocationsOnActions"}
                                        isChecked={state.formdata.locationOnAction[0]}
                                        onSwitchChange={(e) => storeLocations(e)}
                                        showInput={false}

                                    />
                                </div>
                                <div className="col-md-6 col-6">                                               <Tatdate
                                    label='ALERT NOW'
                                    fieldName={"TicketAlertNow"}
                                    isChecked={state.alertNow}
                                    onSwitchChange={(e) => storeAlerNow(e)}
                                    showInput={false}
                                />
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-12 col-12">
                                <div className=' d-flex align-items-center gap-2'>
                                    <label htmlFor="Observers" style={{ fontWeight: '600', fontSize: '14px', marginTop: "4px" }}>OBSERVERS</label>
                                    <p style={{ marginBottom: "2px" }}>
                                        <TooltipButton fieldName="TicketObserver" />
                                    </p>
                                </div>
                                <Textbox
                                    name="Observers"
                                    id="Observers"
                                    placeholder='Select observers'
                                    required={true}
                                    value={state.observerEmpnamelist}
                                    onClick={(e) => setState({ isobserverModal: true })}
                                    readOnly={true}
                                />

                            </div>
                        </div>
                    </div>

                    {
                        state.isobserverModal && <Empmodalbody
                            show={state.isobserverModal}
                            hide={() => setState({ isobserverModal: false })}
                            isMultiple={true}
                            empids={state.observerEmpIdslist}
                            empnames={state.observerEmpnamelist}
                            managers={state.observerEmplist}
                            heading={"Observers"}
                            onChange={(ids, names) =>
                                selectedEmployees(ids, names)
                            }
                        />
                    }
                    {
                        !state.isMultipleStage && <div className="Addstage" style={{ paddingLeft: "15px", display: "flex", alignItems: "center", gap: "10px" }}>
                            <span style={{ fontSize: "14px" }} onClick={(e) => AddStages(e)}>Add Stage</span>
                            
                        </div>
                    }

                    <div className="newStageDiv" style={{ display: state.isMultipleStage ? "block" : 'none' }}>
                        <div className="sequential_parallel_div">
                            <span>Sequential</span>
                            <Switch
                                color="primary"
                                checked={state.isParallel}
                                onChange={(e) => setState({ isParallel: e.target.checked })}
                            />
                            <span className='parallel'>Parallel</span>
                        </div>
                        <div className="alertnowmodal">
                            <div className="row">
                                <div className="col-md-12 col-12">
                                    <div className="row">
                                        <div className="col-md-2 col-5" style={{ padding: "0px" }}>
                                            <p style={{ fontSize: "14px" }}>ALERT NOW</p>
                                        </div>
                                        <div className="col-md-10 col-5" style={{ marginTop: "-4px", padding: "0px" }}>
                                            <Switch
                                                color="primary"
                                                checked={state.alertNow}
                                                onChange={(e) => storeAlerNow(e)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 col-12">
                                <label htmlFor="Observers" style={{ fontWeight: '600', fontSize: '14px' }}>OBSERVERS <span style={{ color: 'red', fontSize: "14px" }}>*</span> </label>
                                <Textbox
                                    name="Observers"
                                    id="Observers"
                                    placeholder='Select observers'
                                    required={true}
                                    value={state.observerEmpnamelist}
                                    onClick={(e) => setState({ isobserverModal: true })}
                                    readOnly={true}
                                />
                            </div>
                        </div>
                        <div className="Addstage" style={{ paddingLeft: "15px", display: "flex", alignItems: "center", gap: "10px" }}>
                            <span style={{ fontSize: "14px" }} onClick={(e) => AddStages(e)}>Add Stage</span>
                           
                        </div>
                        <Table responsive id="myReportTable">
                            <thead>
                                <tr style={{ background: "var(--Primary)", border: "none", color: "white", position: "sticky", top: "0px", zIndex: '1' }}>
                                    {getHeader(state.stageheaders)}
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    state.tableArr.map((data, i) => {
                                        return (
                                            <tr key={i} onClick={() => onEditRow(i)} className="maintablerow">
                                                <td>
                                                    <div className="tablebox stage">
                                                        Stage {i + 1}/{state.tableArr.length}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="photoTablecolumn">
                                                        {
                                                            i != 0 ?
                                                                <span className='topsmallbar'></span>
                                                                : null
                                                        }
                                                        <div style={{ marginRight: "4px" }}><GetImage width={"20px"} height={"20px"} imgID={data.allocatedtoempid} getPhotoUrl={state.getPhotoUrl} /></div>
                                                        <span style={{color:"red"}}>{data.allocatedtoempname}</span>
                                                        {
                                                            i != state.tableArr.length - 1 ?
                                                                <span className='bottomsmallbar'></span>
                                                                : null
                                                        }
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="photoTablecolumn">
                                                        <div style={{ marginRight: "4px" }}><GetImage width={"20px"} height={"20px"} imgID={data.checkedbyempid} getPhotoUrl={state.getPhotoUrl} /></div>
                                                        <span>{data.checkedbyempname}</span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="tablebox">
                                                        {data.predefinedTATstr}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="tablebox">
                                                        <span className='remarks'>{data.remarks}</span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="tablebox">
                                                        <span className='remarks'>{data.dueDateStr}</span>
                                                    </div>
                                                </td>
                                                <td>

                                                    <div className="tablebox">
                                                        <IconButton onClick={(e) => removeTableRow(e,i)}>
                                                            <CloseIcon />
                                                        </IconButton>
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </Table>
                    </div>

                </div>
            </div>

            <Modal centered size="sm" id="loadingModal" animation={true} show={!state.isloadcompleted} onHide={() => setState({ isloadcompleted: true })} style={{ backgroundColor: 'rgba(0,0,0,0.6)' }} backdrop="static" keyboard={false} > {/* backdrop="static" keyboard={false} */}
                <Modal.Body style={{ height: 'auto' }}>
                    <div style={{ display: 'flex', alignItems: 'center', padding: "8px", paddingBottom: "16px" }}>

                        <Loader />
                        <span style={{ paddingLeft: "20px" }}>Loading...</span>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal id="contaxtModal" style={{ backdropFilter: "blur(6px)" }} size={"sm"} centered show={state.isOpenBulkUploadList} onHide={() => setState({ isOpenBulkUploadList: false })}>
                <Modal.Body>

                    <div style={{ borderTop: '', display: "flex", justifyContent: "space-between" }} className='customContaxtMenu' onClick={(e) => ExportFile(e)}>
                        <div style={{ display: "flex" }}>
                            <div style={{ paddingRight: "10px" }}>
                                <DownloadIcon />
                            </div>
                            <span>Download Template</span>
                        </div>
                    </div>
                    <div style={{ borderTop: '1px solid rgba(0,0,0,0.1)', display: "flex", justifyContent: "space-between" }} className='customContaxtMenu'>
                        <div style={{ display: "flex", cursor: "pointer" }} >
                            <div style={{ paddingRight: "10px" }}>
                                <UploadIcon />
                            </div>

                            <input style={{ display: "flex", cursor: "pointer" }} type="file" hidden id="excelfile" onChange={(e) => ImportFile(e)} />
                            <label htmlFor="excelfile" style={{ cursor: "pointer", width: "250px" }}>
                                <span>Upload Data</span>
                            </label>
                        </div>
                    </div>

                    <form action={state.excelDownloadUrl} method="POST" style={{ display: "none" }}>
                        <input type="hidden" id='tabledata' name='tabledata' />
                        <input type="hidden" id='filename' name='filename' />
                        <input type="hidden" id='validations' name='validations' />
                        <button type="submit" id='ExcelExport' />
                    </form>
                </Modal.Body>
            </Modal>
            {
                state.isEditMode ?
                    <Modal centered size="sm" animation={true} show={state.isAddStageModalOpen} onHide={() => setState({ isAddStageModalOpen: false })} style={{ backgroundColor: 'rgba(0,0,0,0.6)' }} backdrop="static" keyboard={false}> {/* backdrop="static" keyboard={false} */}
                        <Modal.Body style={{ height: 'auto' }}>
                            <div>
                                <div className="Stageheader">
                                    <p>Stage {state.editRowId + 1}/{state.defaultStage + 1}</p>
                                    <IconButton onClick={() => closeEditModal()}>
                                        <CloseIcon />
                                    </IconButton>
                                </div>
                                <Inputbox
                                    htmlFor={"ALLOCATED"}
                                    label={"ALLOCATED TO"}
                                    type="text"
                                    labelStyle={{ fontSize: "14px", fontWeight: "600", color: state.stageModalallocatedlabelColor }}
                                    placeholder={`Select Allocated to`}
                                    value={state.editRowData.allocatedtoempnames}
                                    onClick={() => setState({ isOpenAllocatedempmodal: true })}
                                    readOnly={true}
                                    required={true}
                                />
                                <div style={{ marginBottom: "10px" }}></div>
                                <Inputbox
                                    htmlFor={"CHECKED"}
                                    label={"CHECKED BY"}
                                    type="text"
                                    labelStyle={{ fontSize: "14px", fontWeight: "600", color: state.stageModalCheckedbylabelColor }}
                                    placeholder={`Select Checked By`}
                                    value={state.editRowData.checkedbyempnames}
                                    onClick={() => setState({ isOpenCheckedempmodal: true })}
                                    readOnly={true}
                                    required={true}
                                />
                                <div style={{ marginBottom: "10px" }}></div>
                                <Inputbox
                                    wordboundation={{ limit: 150, id: `remarks${state.defaultStage}Input` }}
                                    htmlFor={"REMARKS"}
                                    label={"REMARKS"}
                                    value={state.editRowData.remarks}
                                    onChange={(e) => storeRemarksValue(e)}
                                    type="text"
                                    labelStyle={{ fontSize: "14px", fontWeight: "600", color: "black" }}
                                    placeholder={`Enter value`}
                                    required={false}
                                />
                                <div className="predefinedTAT">

                                    <Tatdate
                                        iscol={true}
                                        label='PREDEFINED TAT'
                                        fieldName="TicketPredefinedTAT"
                                        isChecked={state.editRowData.isPredefinedTATSelected}
                                        onSwitchChange={(e) => OpenTATModal(e)}
                                        isdiff={true}
                                        inputValue={state.editRowData.predefinedTATStr}
                                        onInputClick={() => setState({ isOpenTATmodal: true })}
                                    />

                                </div>

                                <div style={{ marginBottom: "10px" }}></div>

                                <div className="predefinedTATt">
                                    <Tatdate
                                        iscol={true}
                                        label='LOCATIONS ON ACTIONS'
                                        fieldName={"TicketLocationsOnActions"}
                                        isChecked={state.editRowData.locationOnAction}
                                        onSwitchChange={(e) => storeLocations(e)}
                                        showInput={false}
                                        isdiff={true}

                                    />
                                </div>

                                <div className="predefinedTATt">
                                    <Tatdate
                                        iscol={true}
                                        label='DUE DATE'
                                        fieldName={"TicketDueDate"}
                                        isChecked={state.editRowData.isDueDateSelected}
                                        onSwitchChange={(e) => openDueDateModal(e)}
                                        isdiff={true}
                                        inputValue={state.editRowData.dueDateStr}
                                        onInputClick={() => setState({ isOpenDueDateModal: true })}
                                    />
                                </div>

                                <div className="StageOKbtn">
                                    <span onClick={() => onAddStageSuccess()}>OK</span>
                                </div>
                            </div>
                        </Modal.Body>
                    </Modal>
                    :
                    <Modal centered size="sm" animation={true} show={state.isAddStageModalOpen} onHide={() => setState({ isAddStageModalOpen: false })} style={{ backgroundColor: 'rgba(0,0,0,0.6)' }} backdrop="static" keyboard={false}> {/* backdrop="static" keyboard={false} */}
                        <Modal.Body style={{ height: 'auto' }}>
                            <div>
                                <div className="Stageheader">
                                    <p>Stage {state.defaultStage + 1}/{state.defaultStage + 1}</p>
                                    <IconButton onClick={() => closeStageModal()}>
                                        <CloseIcon />
                                    </IconButton>
                                </div>
                                <Inputbox
                                    htmlFor={"ALLOCATED"}
                                    label={"ALLOCATED TO"}
                                    type="text"
                                    labelStyle={{ fontSize: "14px", fontWeight: "600", color: state.stageModalallocatedlabelColor }}
                                    placeholder={`Select Allocated to`}
                                    value={state.formdata.allocatedtoempnames[state.defaultStage]}
                                    onClick={() => setState({ isOpenAllocatedempmodal: true })}
                                    readOnly={true}
                                    required={true}
                                />

                                <Inputbox
                                    htmlFor={"CHECKED"}
                                    label={"CHECKED BY"}
                                    type="text"
                                    labelStyle={{ fontSize: "14px", fontWeight: "600", color: state.stageModalCheckedbylabelColor }}
                                    placeholder={`Select Checked By`}
                                    value={state.formdata.checkedbyempnames[state.defaultStage]}
                                    onClick={() => setState({ isOpenCheckedempmodal: true })}
                                    readOnly={true}
                                    required={true}
                                />
                                <div style={{ marginBottom: "10px" }}></div>
                                <Inputbox
                                    wordboundation={{ limit: 150, id: `remarks${state.defaultStage}Input` }}
                                    htmlFor={"REMARKS"}
                                    label={"REMARKS"}
                                    value={state.formdata.remarks[state.defaultStage]}
                                    onChange={(e) => storeRemarksValue(e)}
                                    type="text"
                                    labelStyle={{ fontSize: "14px", fontWeight: "600", color: "black" }}
                                    placeholder={`Enter value`}
                                    required={false}
                                />

                                <div className="predefinedTATt">

                                    <Tatdate
                                        iscol={true}
                                        label='PREDEFINED TAT'
                                        fieldName="TicketPredefinedTAT"
                                        isChecked={state.formdata.isPredefinedTATSelected[state.defaultStage]}
                                        onSwitchChange={(e) => OpenTATModal(e)}
                                        isdiff={true}
                                        inputValue={state.formdata.predefinedTATStr[state.defaultStage]}
                                        onInputClick={() => setState({ isOpenTATmodal: true })}
                                    />

                                </div>
                                <div style={{ marginBottom: "10px" }}></div>

                                <div className="predefinedTATt">
                                    <Tatdate
                                        iscol={true}
                                        label='LOCATIONS ON ACTIONS'
                                        fieldName={"TicketLocationsOnActions"}
                                        isChecked={state.formdata.locationOnAction[state.defaultStage]}
                                        onSwitchChange={(e) => storeLocations(e)}
                                        showInput={false}
                                        isdiff={true}
                                    />
                                </div>

                                <div className="predefinedTATt">
                                    <Tatdate
                                        iscol={true}
                                        label='DUE DATE'
                                        fieldName={"TicketDueDate"}
                                        isChecked={state.formdata.isDueDateSelected[state.defaultStage]}
                                        onSwitchChange={(e) => openDueDateModal(e)}
                                        isdiff={true}
                                        inputValue={state.formdata.dueDateStr[state.defaultStage]}
                                        onInputClick={() => setState({ isOpenDueDateModal: true })}
                                    />
                                </div>
                                <div className="StageOKbtn">
                                    <span onClick={() => onAddStageSuccess()}>OK</span>
                                </div>
                            </div>
                        </Modal.Body>
                    </Modal>
            }
            <Modal style={{ backdropFilter: "blur(4px)", zIndex:999999, backgroundColor:"#0000003d" }} centered onEntered={() => setState({ setFocus: true })} show={state.isOpencategorymodal} onHide={() => setState({ isOpencategorymodal: false })} backdrop="static" keyboard={false}>

                <Modal.Body style={{ paddingTop: "0px", overflow: "hidden" }}>
                    <MyModalBody onclose={() => setState({ isOpencategorymodal: false })} setFocus={state.setFocus} callback={getCategoryID} />
                </Modal.Body>
            </Modal>
            {
                state.isOpenAllocatedempmodal && (<Empmodal selecttext="Select Employee" onChange={getAllocuserid} show={state.isOpenAllocatedempmodal} handleclose={() => setState({ isOpenAllocatedempmodal: false })} data={state.AllocatedToEmpList} />
                )
            }

            {
                state.isOpenCheckedempmodal && <Empmodal selecttext="Select Employee" onChange={getCheckuserid} show={state.isOpenCheckedempmodal} handleclose={() => setState({ isOpenCheckedempmodal: false })} data={state.CheckedByEmpList} />
            }
            {/* <Modal className="DateModalBody" centered style={{ borderRadius: "0px", backgroundColor: 'rgba(0,0,0,0.6)' }} show={state.isOpenDueDateModal}>
                <Modal.Body>
                    <DatePicker
                        openDatePicker={state.isOpenDueDateModal}
                        onHideDatePicker={() => setState({ isOpenDueDateModal: false })}
                        onChange={(date) => getDueDate(date)}
                        defaults={state.formdata.dueDate[state.defaultStage]}
                        disablePast={true}
                    />
                </Modal.Body>
            </Modal> */}

{
    duedateconfig ? (
        state.isOpenDueDateModal && (
            <Datetimepicker
                defaults={state.formdata.dueDate[state.defaultStage]}
                onChange={(date) => getDueDate(date)}
                onHide={() => {
    if (!state.formdata.dueDateStr[state.defaultStage]) {
        state.formdata.isDueDateSelected[state.defaultStage] = false
    }
    setState({ isOpenDueDateModal: false, renderAgain: true })
}}
                disablePast={true}
            />
        )
    ) : (
        <Modal className="DateModalBody" centered style={{ borderRadius: "0px", backgroundColor: 'rgba(0,0,0,0.6)' }} show={state.isOpenDueDateModal}>
            <Modal.Body>
                <DatePicker
                    openDatePicker={state.isOpenDueDateModal}
                    onHideDatePicker={() => {

 if (!state.formdata.dueDateStr[state.defaultStage]) {
        state.formdata.isDueDateSelected[state.defaultStage] = false
    }

setState({ isOpenDueDateModal: false, renderAgain: true })
} }
                    onChange={(date) => getDueDate(date)}
                    defaults={state.formdata.dueDate[state.defaultStage]}
                    disablePast={true}
                />
            </Modal.Body>
        </Modal>
    )
}

            <Modal style={{ backgroundColor: 'rgba(0,0,0,0.6)' }} show={state.isOpenTATmodal} centered onHide={() => {
                CloseTATModal()
                setState({ isOpenTATmodal: !state.isOpenTATmodal })
            }
            }
                backdrop="static" keyboard={false}>
                <Modal.Header style={{ display: "flex", padding: "10px", justifyContent: "space-between", alignContent: "center" }}>
                    <p style={{ fontSize: "18px", color: "#0cc1e6", marginBottom: "0px" }}>Select TAT</p>
                    <IoCloseOutline style={{ fontSize: "24px", cursor: "pointer", color: "gray" }} onClick={() => {
                        setState({ isOpenTATmodal: false })
                        CloseTATModal()

                    }} />

                </Modal.Header>
                <Modal.Body style={{ height: "160px" }}>
                    <TATModalBody callback={(tat, str) => getTATvalue(tat, str)} defaults={state.formdata.predefinedTat[state.defaultStage]} />
                </Modal.Body>
            </Modal>

            
            <Modal centered size="sm" animation={true} show={state.isOpenBulkStageModal} onHide={() => closeBulkStageModal()} style={{ backgroundColor: 'rgba(0,0,0,0.6)' }} backdrop="static" keyboard={false}>
                <Modal.Body style={{ height: 'auto' }}>
                    <div>
                        <div className="Stageheader" style={{ justifyContent: "center", position: "relative" }}>
                            <p style={{ fontSize: "22px", fontWeight: "700", color: "#0cc1e6", marginBottom: "0px" }}>Bulk Stage Ticket</p>
                            <IconButton onClick={() => closeBulkStageModal()} style={{ position: "absolute", right: 0, top: 0 }}>
                                <CloseIcon />
                            </IconButton>
                        </div>
                        <Inputbox
                            htmlFor={"BULKALLOCATED"}
                            label={"ALLOCATED TO"}
                            type="text"
                            labelStyle={{ fontSize: "14px", fontWeight: "600", color: state.bulkAllocatedLabelColor }}
                            placeholder={`Select allocated to`}
                            value={state.bulkAllocatedEmpNames}
                            onClick={() => setState({ isOpenBulkAllocatedModal: true })}
                            readOnly={true}
                            required={true}
                        />

                        <div style={{ marginBottom: "10px" }}></div>
                        <Inputbox
                            htmlFor={"BULKCHECKED"}
                            label={"CHECKED BY"}
                            type="text"
                            labelStyle={{ fontSize: "14px", fontWeight: "600", color: state.bulkCheckedByLabelColor }}
                            placeholder={`Select checked By`}
                            value={state.bulkCheckedByEmpName}
                            onClick={() => setState({ isOpenBulkCheckedEmpModal: true })}
                            readOnly={true}
                            required={true}
                        />
                        <div style={{ marginBottom: "10px" }}></div>
                        <Inputbox
                            wordboundation={{ limit: 500, id: 'bulkRemarksInput' }}
                            htmlFor={"BULKREMARKS"}
                            label={"REMARKS"}
                            value={state.bulkRemarks}
                            onChange={(e) => setState({ bulkRemarks: e.target.value })}
                            type="text"
                            labelStyle={{ fontSize: "14px", fontWeight: "600", color: "black" }}
                            placeholder={`Enter Value`}
                            required={false}
                        />
                        <div className="predefinedTAT">
                            <Tatdate
                                iscol={true}
                                label='PREDEFINED TAT'
                                fieldName="BulkPredefinedTAT"
                                isChecked={state.bulkIsPredefinedTATSelected}
                                onSwitchChange={(e) => {
                                    setState({ bulkIsPredefinedTATSelected: e.target.checked, isOpenBulkTATmodal: e.target.checked })
                                    if (!e.target.checked) {
                                        setState({ bulkPredefinedTat: '-1', bulkPredefinedTATStr: '' })
                                    }
                                }}
                                isdiff={true}
                                inputValue={state.bulkPredefinedTATStr}
                                onInputClick={() => setState({ isOpenBulkTATmodal: true })}
                            />
                        </div>
                        <div style={{ marginBottom: "10px" }}></div>
                        <div className="predefinedTATt">
                            <Tatdate
                                iscol={true}
                                label='LOCATION ON ACTIONS'
                                fieldName={"BulkLocationsOnActions"}
                                isChecked={state.bulkLocationOnAction}
                                onSwitchChange={(e) => setState({ bulkLocationOnAction: e.target.checked })}
                                showInput={false}
                                isdiff={true}
                            />
                        </div>
                        <div className="predefinedTATt">
                            <Tatdate
                                iscol={true}
                                label='DUE DATE'
                                fieldName={"BulkDueDate"}
                                isChecked={state.bulkIsDueDateSelected}
                                onSwitchChange={(e) => {
                                    setState({ bulkIsDueDateSelected: e.target.checked, isOpenBulkDueDateModal: e.target.checked })
                                    if (!e.target.checked) {
                                        setState({ bulkDueDate: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'), bulkDueDateStr: '' })
                                    }
                                }}
                                isdiff={true}
                                inputValue={state.bulkDueDateStr}
                                onInputClick={() => setState({ isOpenBulkDueDateModal: true })}
                            />
                        </div>
                        <div className="StageOKbtn">
                            <span onClick={() => submitBulkStage()}>OK</span>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            {
                state.isOpenBulkAllocatedModal && <Empmodalbody
                    show={state.isOpenBulkAllocatedModal}
                    hide={() => setState({ isOpenBulkAllocatedModal: false })}
                    isMultiple={true}
                    empids={state.bulkAllocatedEmpIds}
                    empnames={state.bulkAllocatedEmpNames}
                    managers={state.AllocatedToEmpList}
                    heading={"Allocated To"}
                    onChange={(ids, names) => getBulkAllocatedEmployees(ids, names)}
                />
            }

            {
                state.isOpenBulkCheckedEmpModal && <Empmodal selecttext="Select Employee" onChange={getBulkCheckedByEmp} show={state.isOpenBulkCheckedEmpModal} handleclose={() => setState({ isOpenBulkCheckedEmpModal: false })} data={state.CheckedByEmpList} />
            }

            {/* <Modal className="DateModalBody" centered style={{ borderRadius: "0px", backgroundColor: 'rgba(0,0,0,0.6)' }} show={state.isOpenBulkDueDateModal}>
                <Modal.Body>
                    <DatePicker
                        openDatePicker={state.isOpenBulkDueDateModal}
                        onHideDatePicker={() => setState({ isOpenBulkDueDateModal: false })}
                        onChange={(date) => getBulkDueDate(date)}
                        defaults={state.bulkDueDate}
                        disablePast={true}
                    />
                </Modal.Body>
            </Modal> */}
{
    duedateconfig ? (
        state.isOpenBulkDueDateModal && (
            <Datetimepicker
                defaults={state.bulkDueDate}
                onChange={(date) => getBulkDueDate(date)}
                onHide={() => {
                    if (!state.bulkDueDateStr) {
                        state.bulkIsDueDateSelected = false
                    }
                    setState({ isOpenBulkDueDateModal: false, renderAgain: true })
                }}
                disablePast={true}
            />
        )
    ) : (
        <Modal className="DateModalBody" centered style={{ borderRadius: "0px", backgroundColor: 'rgba(0,0,0,0.6)' }} show={state.isOpenBulkDueDateModal}>
            <Modal.Body>
                <DatePicker
                    openDatePicker={state.isOpenBulkDueDateModal}
                     onHideDatePicker={() => {
                        if (!state.bulkDueDateStr) {
                            state.bulkIsDueDateSelected = false
                        }
                        setState({ isOpenBulkDueDateModal: false, renderAgain: true })
                    }}
                    onChange={(date) => getBulkDueDate(date)}
                    defaults={state.bulkDueDate}
                    disablePast={true}
                />
            </Modal.Body>
        </Modal>
    )
}
            <Modal style={{ backgroundColor: 'rgba(0,0,0,0.6)' }} show={state.isOpenBulkTATmodal} centered onHide={() => closeBulkTATModal()} backdrop="static" keyboard={false}>
                <Modal.Header style={{ display: "flex", padding: "10px", justifyContent: "space-between", alignContent: "center" }}>
                    <p style={{ fontSize: "18px", color: "#0cc1e6", marginBottom: "0px" }}>Select TAT</p>
                    <IoCloseOutline style={{ fontSize: "24px", cursor: "pointer", color: "gray" }} onClick={() => closeBulkTATModal()} />
                </Modal.Header>
                <Modal.Body style={{ height: "160px" }}>
                    <TATModalBody callback={(tat, str) => getBulkTATvalue(tat, str)} defaults={state.bulkPredefinedTat} />
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default withRouter(Addticket)
